
// SVG Icon: back-to-start
export default { id: "terriajs-back-to-start" };
export const id = "terriajs-back-to-start";
export const name = "back-to-start";
